import React from 'react';

function ReferAFriend({ size, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <path d="M7.5 8C8.88071 8 10 6.88071 10 5.5C10 4.11929 8.88071 3 7.5 3C6.11929 3 5 4.11929 5 5.5C5 6.88071 6.11929 8 7.5 8Z" />
      <path d="M16.0001 15C18.2092 15 20.0001 13.2091 20.0001 11C20.0001 8.79086 18.2092 7 16.0001 7C13.7909 7 12.0001 8.79086 12.0001 11C12.0001 13.2091 13.7909 15 16.0001 15Z" />
      <path d="M3 12C3 10 5.25 8 7.5 8C9.75 8 12 9.66667 12 12" />
      <path d="M10 21C10 18 13 15 16 15C19 15 22 17.5 22 21" />
    </svg>
  );
}

export default ReferAFriend;
